import { render, staticRenderFns } from "./ViewAllNotifications.vue?vue&type=template&id=44eb4864&scoped=true&"
import script from "./ViewAllNotifications.vue?vue&type=script&lang=js&"
export * from "./ViewAllNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllNotifications.vue?vue&type=style&index=0&id=44eb4864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eb4864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44eb4864')) {
      api.createRecord('44eb4864', component.options)
    } else {
      api.reload('44eb4864', component.options)
    }
    module.hot.accept("./ViewAllNotifications.vue?vue&type=template&id=44eb4864&scoped=true&", function () {
      api.rerender('44eb4864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Notifications/ViewAllNotifications.vue"
export default component.exports